/**
 * Compares one object to another by their Id.
 * Use to compare an already selected value to one of the available,
 * so this option is rendered in the select input or in a read view.
 */
export function compareById<T extends { id: number | string }>(a: T, b: T): boolean {
	return a?.id === b?.id;
}
